let xhr = require('client/xhr');
let Spinner = require('client/spinner');
let delegate = require('client/delegate');
let notification = require('client/notification');
let clientRender = require('client/clientRender');
let commentForm = require('../../templates/feedback/comment-form.pug');
const t = require('engine/i18n/t');
const LANG = require('config').lang;

t.i18n.add('courses', require('../../locales/' + LANG + '.yml'));

class FeedbackManager {

  constructor() {

    this.elem = document;

    this.delegate("[data-action-coursefeedback-comment-add]", "click", (event) => {
      event.preventDefault();
      this.getItem(event.target).addComment();
    });

    this.delegate("[data-action-coursefeedback-comment-edit]", "click", (event) => {
      event.preventDefault();
      this.getItem(event.target).editComment();
    });

  }

  getItem(elem) {
    elem = elem.closest('.course-feedback');
    if (!elem.feedbackItem) {
      elem.feedbackItem = new FeedbackItem(elem);
    }
    return elem.feedbackItem;
  }

}
delegate.delegateMixin(FeedbackManager.prototype);

class FeedbackItem {
  constructor(elem) {
    this.elem = elem;

    this.number = +elem.getAttribute('data-coursefeedback-number');

    let commentStore = this.elem.querySelector('[data-coursefeedback-comment-raw]');
    this.teacherCommentRaw = commentStore ? commentStore.innerHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/ ,'&') : '';

    this.delegate(".course-feedback-comment-form", "submit", (event) => {
      event.preventDefault();
      this.onSubmitComment();
    });

    this.delegate("[data-action-comment-cancel]", "click", (event) => {
      event.preventDefault();
      this.onCancelComment();
    });

    document.addEventListener('profile-tab-change', this.onCancelComment.bind(this));
  }

  addComment() {
    this.renderCommentForm();
  }

  editComment() {
    this.renderCommentForm();
  }

  renderCommentForm() {
    let teacherCommentElem = this.elem.querySelector('.course-feedback__teacher-comment');
    if (teacherCommentElem) {
      this.teacherComment = teacherCommentElem.firstChild.innerHTML;
    } else {
      this.teacherComment = "";
      teacherCommentElem = document.createElement('div');
      teacherCommentElem.className = 'course-feedback__teacher-comment';
      this.elem.querySelector('.course-feedback__teacher').appendChild(teacherCommentElem);
    }

    teacherCommentElem.innerHTML = clientRender(commentForm, {
      teacherCommentRaw: this.teacherCommentRaw
    });
    teacherCommentElem.querySelector('textarea').focus();
  }

  onCancelComment() {
    this.renderComment();
  }

  onSubmitComment() {
    let form = this.elem.querySelector('form');
    let value = form.elements.teacherComment.value.trim();

    const request = xhr({
      method: 'PATCH',
      url:    '/courses/feedback/comment',
      body:   {
        number: this.number,
        teacherComment: value
      }
    });

    let submitButton = form.querySelector('[type="submit"]');

    let spinner = new Spinner({
      elem:      submitButton,
      size:      'small',
      elemClass: 'button_loading'
    });
    spinner.start();
    submitButton.disabled = true;

    request.addEventListener('loadend', (event) => {
      spinner.stop();
      submitButton.disabled = false;
    });

    request.addEventListener('success', (event) => {

      if (request.status == 200) {
        new notification.Success(t('courses.group_feedback_show.comment_saved'));

        this.teacherCommentRaw = value;
        this.teacherComment = event.result.teacherComment;

        this.renderComment();
      } else {
        new notification.Error(t('courses.group_feedback_show.comment_save_error'));
      }
    });



  }

  renderComment() {
    let teacherCommentElem = this.elem.querySelector('.course-feedback__teacher-comment');

    if (!this.teacherComment) {
      if (teacherCommentElem) teacherCommentElem.remove();
      this.elem.querySelector('[data-action-coursefeedback-comment-add]').style.display = '';
      return;
    }

    this.elem.querySelector('[data-action-coursefeedback-comment-add]').style.display = 'none';

    teacherCommentElem.innerHTML = `<div></div>
          <a class="course-feedback__edit" href='#' data-action-coursefeedback-comment-edit>${t('courses.group_feedback_show.edit')}</a>
          `;
    teacherCommentElem.firstChild.innerHTML = this.teacherComment;
  }

}

delegate.delegateMixin(FeedbackItem.prototype);

function init() {

  new FeedbackManager();

}


init();
